<template>
    <div class="box">
  
      
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6">
                    <a-form-item label="工序名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入工序名称" v-model="queryParam.proceName"></a-input>
                    </a-form-item>
                  </a-col>
                  
                  <a-col :md="6">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-col :md="6" :sm="24">
                        <a-button type="primary" @click="searchQuery">查询</a-button>
                        <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                      </a-col>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
              <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
            </div>
  
            <!-- table区域-begin -->
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="filteredColumns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                @change="handleTableChange">
                <span slot="action" slot-scope="text, record">
                  <a @click="bindTemplate(record)">绑定规则</a>
                  <a-divider type="vertical" />
                  <a @click="bindTraceTemplate(record)">绑定追溯模板</a>
                  <a-divider type="vertical" />
                  <a @click="handleEdit(record)">编辑</a>
                  <!-- <a-divider type="vertical" />
                  <a @click="begin(record)">开始</a> -->
                  <!-- <a-divider type="vertical" />
                  <a @click="getDetail(record)">查看详情</a> -->
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <add-process ref="addProccessRef" @ok="modalFormOk" @close="modalFormClose"></add-process>
      <begin-dialog ref="BeginDialogRef" @ok="BeginDialogOk"></begin-dialog>
      <bind-rule-list ref="bindRuleList" @update:codeRuleId="onCodeRuleIdUpdate" @ok="bindRuleListOk" @close="handleSubComponentClose"></bind-rule-list>
      <bind-trace-module-list ref="bindTraceModuleList" @ok="bindTraceModuleListOk" @update:traceTemplateId="onTraceTemplateIdUpdate" @close="handleTraceTemplateClose"></bind-trace-module-list>
      <event-trace-list ref="traceListRef" @ok="traceListOk" @close="closeTraceList"></event-trace-list>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
    import BeginDialog from './modules/beginDialog'
    import AddProcess from './modules/addProcess.vue'
    import BindRuleList from './modules/bindRuleList.vue'
    import EventTraceList from './modules/eventTraceList.vue'
    import BindTraceModuleList from './modules/bindTraceModuleList.vue'
    import { delProcess, getAll } from '@/api/api'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        BeginDialog,
        AddProcess,
        BindRuleList,
        BindTraceModuleList,
        EventTraceList
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
          
          // 查询条件
          queryParam: {
            isStandard: '1',
            segmentType: 1,
          },
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {title: '工序名称 ', dataIndex: 'proceName', align:"center",},
            {title: '工序编码 ', dataIndex: 'proceCode', align:"center",},
            {title: '工序序号 ', dataIndex: 'seq', align:"center",},
            {title: '事件规则 ', dataIndex: 'codeRuleId', align:"center",},
            {title: '追溯模版 ', dataIndex: 'formTemplateId', align:"center",},
            {
              title: '事件名称 ', 
              dataIndex: 'codeRuleName', 
              align:"center",
              customRender: function (value) {
                return value || '--';
              }
            },
            {
              title: '追溯名称 ', 
              dataIndex: 'formTemplateName', 
              align:"center",
              customRender: function (value) {
                return value || '--';
              }
            },
            {
              title: '操作',
              dataIndex: 'action',
              width: '30%',
              align:"center",
              scopedSlots: { customRender: 'action' },
            },
          ],
          // 控制列的显示状态
          columnVisibility: {
            codeRuleId: false, // 设置为 false 隐藏该列
            formTemplateId: false, // 设置为 false 隐藏该列
            proceCode: false
          },
          // url: {
          //   list: "/process/getAll",
          //   delete: "/codeRules/fzRule/delete",
          //   deleteBatch: "/codeRules/fzRule/deleteBatch"
          // },
          visibleRuleNode: false, // 规则节点抽屉开关
          uuid: '', // 每一项的uuid
  
          // 下拉框数据
          ruleSystem: [], // 发码机构
          ruleCategory: [], // 参考标准
          ruleLabel: [] // 类别
        }
      },
      mounted() {
        // 获取列表
        this.getList()
      },
      computed: {
        filteredColumns() {
          return this.columns.filter(column => {
            if (column.dataIndex in this.columnVisibility) {
              return this.columnVisibility[column.dataIndex];
            }
            return true;
          });
        }
      },
      methods: {
        show(e){
          console.log(e,'process==============================')
        },
        searchQuery(){
          this.getList(this.queryParam.proceName)
        },
        searchReset(){
          this.getList()
          this.queryParam.proceName = ''
        },
        async getList(){
          const params = {
            proceName: this.queryParam.proceName,
            segmentType: 1,
            pageNo: 1,
            pageSize: 10,
          }
          const res = await getAll(params)
          if( res.code == 200 && res.success == true ){
            this.dataSource = res.result.records
          }
        },
        // 
        modalFormOk(){
          this.loadData()
        },
        modalFormClose(){

        },
        traceListOk(){ },
        closeTraceList(){

        },
        bindRuleListOk(){

        },
        bindTraceModuleListOk(){

        },
        handleAdd(){
          this.$refs.addProccessRef.add()
        },
        handleEdit(record){
            this.$refs.addProccessRef.edit(record)
        },
        chooseTemplateOk(){
          this.loadData()
        },
        bindTemplate(record){
          this.$refs.bindRuleList.show(record) // 获取生码
        },
        onCodeRuleIdUpdate(newId){
            this.codeRuleId = newId;
            console.log('新的规则ID:', newId);
        },
        onTraceTemplateIdUpdate(newId){
            this.formTemplateId = newId;
            console.log('新的模版ID:', newId);
        },
        handleSubComponentClose() {
            this.loadData(); // 刷新父组件数据
        },
        handleTraceTemplateClose() {
            this.loadData(); // 刷新父组件数据
        },
        bindTraceTemplate(record){
          this.$refs.bindTraceModuleList.show(record) // 绑定追溯模版
        },
        bindTemplateOk(){
          this.loadData()
        },
        
        // 规则节点抽屉变化事件
        afterVisibleChange(val) {
          console.log('visible', val)
  
        },
        // 规则节点抽屉关闭 - 点击事件
        onClose() {
          this.visibleRuleNode = false;
        },
        begin(record){
            this.$refs.BeginDialogRef.open(record)
            
        },
        //获取选择信息
        getSelectRows(rowId) {
          let dataSource = this.dataSource;
          let ids = "";
          this.selectRows = [];
          for (let i = 0, len = dataSource.length; i < len; i++) {
            if (this.selectedRowKeys.includes(dataSource[i].id)) {
              this.selectRows.push(dataSource[i]);
              ids = ids + "," + dataSource[i].batchNumber
            }
          }
          this.selectIds = ids.substring(1);
        },
        onSelectChange(selectedRowKeys, selectionRows) {
          this.selectedRowKeys = selectedRowKeys;
          this.selectionRows = selectionRows;
        },
        // 删除
        async handleDelete(id){
          const res = await delProcess(id)
          if( res.code == 200 && res.success == true ){
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        },
        // 查看详情
        getDetail(record){
          this.$refs.traceListRef.show(record)
        },
        BeginDialogOk(){

        }
  
      },
      watch: {
        current() {
          this.queryParam.isStandard = this.current[0] === 'enterpriseRule' ? '1' : '0' // 规则查询参数
          this.loadData(1)
        }
      },
      created() {
        // 获取发码机构下拉框
        queryEnableDictItemsByCode({code: 'send_code_org'})
        .then(res => {
          this.ruleSystem = res
        })
        // 获取参考标准下拉框
        queryEnableDictItemsByCode({code: 'Reference_Standards'})
        .then(res => {
          this.ruleCategory = res
        })
        // 获取类别单选框
        queryEnableDictItemsByCode({code: 'rule_code_type'})
        .then(res => {
          this.ruleLabel = res
        })
      }
    }
  </script>
  
  <style scoped>
    @import '~@assets/less/common.less'
  </style>